/**
 * ComponentProfile — UML Component / Deployment / Composite Structure diagrams.
 * See plans/software-design/domain.md § 4.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type ComponentNodeType = 'comp_component' | 'comp_package' | 'comp_database' | 'comp_queue' | 'comp_node' | 'comp_artifact';
export type ComponentEdgeType = 'comp_depends' | 'comp_provides' | 'comp_requires' | 'comp_deploys';

export const ComponentProfile: DomainDataProfile<ComponentNodeType, ComponentEdgeType> = {
  domainId: 'component',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['comp_component', 'comp_package', 'comp_database', 'comp_queue', 'comp_node', 'comp_artifact'],
  edgeTypes: ['comp_depends', 'comp_provides', 'comp_requires', 'comp_deploys'],
  vocabulary: {
    recordSingular: 'Component',
    recordPlural: 'Components',
    repositoryLabel: 'System',
    hierarchyLabel: 'Contains',
    importAction: 'Import Components',
    keyColumnHint: 'Component',
    commitLabel: 'Push Components',
    pullLabel: 'Refresh Components',
    diagramLabel: 'component diagram',
  },
  fieldAliases: {
    name: ['componentName', 'component'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'comp_component',
  propsToAttrsMapping: {
    name: 'name',
    stereotype: 'stereotype',
    technology: 'technology',
  },
  relationshipPackId: 'software-design-relationships',
};
